/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetFwLeaderboardsActiveTotalActiveTotal } from './GetFwLeaderboardsActiveTotalActiveTotal';
import {
    GetFwLeaderboardsActiveTotalActiveTotalFromJSON,
    GetFwLeaderboardsActiveTotalActiveTotalFromJSONTyped,
    GetFwLeaderboardsActiveTotalActiveTotalToJSON,
    GetFwLeaderboardsActiveTotalActiveTotalToJSONTyped,
} from './GetFwLeaderboardsActiveTotalActiveTotal';
import type { GetFwLeaderboardsYesterdayYesterday } from './GetFwLeaderboardsYesterdayYesterday';
import {
    GetFwLeaderboardsYesterdayYesterdayFromJSON,
    GetFwLeaderboardsYesterdayYesterdayFromJSONTyped,
    GetFwLeaderboardsYesterdayYesterdayToJSON,
    GetFwLeaderboardsYesterdayYesterdayToJSONTyped,
} from './GetFwLeaderboardsYesterdayYesterday';
import type { GetFwLeaderboardsLastWeekLastWeek } from './GetFwLeaderboardsLastWeekLastWeek';
import {
    GetFwLeaderboardsLastWeekLastWeekFromJSON,
    GetFwLeaderboardsLastWeekLastWeekFromJSONTyped,
    GetFwLeaderboardsLastWeekLastWeekToJSON,
    GetFwLeaderboardsLastWeekLastWeekToJSONTyped,
} from './GetFwLeaderboardsLastWeekLastWeek';

/**
 * Top 4 rankings of factions by number of kills from yesterday, last week and in total
 * @export
 * @interface GetFwLeaderboardsKills
 */
export interface GetFwLeaderboardsKills {
    /**
     * Top 4 ranking of factions active in faction warfare by total kills. A faction is considered "active" if they have participated in faction warfare in the past 14 days
     * @type {Array<GetFwLeaderboardsActiveTotalActiveTotal>}
     * @memberof GetFwLeaderboardsKills
     */
    activeTotal: Array<GetFwLeaderboardsActiveTotalActiveTotal>;
    /**
     * Top 4 ranking of factions by kills in the past week
     * @type {Array<GetFwLeaderboardsLastWeekLastWeek>}
     * @memberof GetFwLeaderboardsKills
     */
    lastWeek: Array<GetFwLeaderboardsLastWeekLastWeek>;
    /**
     * Top 4 ranking of factions by kills in the past day
     * @type {Array<GetFwLeaderboardsYesterdayYesterday>}
     * @memberof GetFwLeaderboardsKills
     */
    yesterday: Array<GetFwLeaderboardsYesterdayYesterday>;
}

/**
 * Check if a given object implements the GetFwLeaderboardsKills interface.
 */
export function instanceOfGetFwLeaderboardsKills(value: object): value is GetFwLeaderboardsKills {
    if (!('activeTotal' in value) || value['activeTotal'] === undefined) return false;
    if (!('lastWeek' in value) || value['lastWeek'] === undefined) return false;
    if (!('yesterday' in value) || value['yesterday'] === undefined) return false;
    return true;
}

export function GetFwLeaderboardsKillsFromJSON(json: any): GetFwLeaderboardsKills {
    return GetFwLeaderboardsKillsFromJSONTyped(json, false);
}

export function GetFwLeaderboardsKillsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsKills {
    if (json == null) {
        return json;
    }
    return {
        
        'activeTotal': ((json['active_total'] as Array<any>).map(GetFwLeaderboardsActiveTotalActiveTotalFromJSON)),
        'lastWeek': ((json['last_week'] as Array<any>).map(GetFwLeaderboardsLastWeekLastWeekFromJSON)),
        'yesterday': ((json['yesterday'] as Array<any>).map(GetFwLeaderboardsYesterdayYesterdayFromJSON)),
    };
}

export function GetFwLeaderboardsKillsToJSON(json: any): GetFwLeaderboardsKills {
    return GetFwLeaderboardsKillsToJSONTyped(json, false);
}

export function GetFwLeaderboardsKillsToJSONTyped(value?: GetFwLeaderboardsKills | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active_total': ((value['activeTotal'] as Array<any>).map(GetFwLeaderboardsActiveTotalActiveTotalToJSON)),
        'last_week': ((value['lastWeek'] as Array<any>).map(GetFwLeaderboardsLastWeekLastWeekToJSON)),
        'yesterday': ((value['yesterday'] as Array<any>).map(GetFwLeaderboardsYesterdayYesterdayToJSON)),
    };
}

